import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Standardized loading indicator.
 *
 * Props:
 *   message   — screen-reader + visual label (default: "Loading…")
 *   fullPage  — use 60vh min-height (true) or 200px (false, default)
 *   size      — CircularProgress size prop (default: 40)
 */
const LoadingSpinner = ({ message = 'Loading…', fullPage = false, size = 40 }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    minHeight={fullPage ? '60vh' : 200}
    gap={2}
    role="status"
    aria-label={message}
  >
    <CircularProgress size={size} aria-hidden="true" />
    <Typography color="text.secondary" variant="body2">
      {message}
    </Typography>
  </Box>
);

export default LoadingSpinner;
